import React from 'react';
import { Box, Container, Typography, Link, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { drawerWidth } from 'store/constant';

// ==============================|| FOOTER ||============================== //

const StyledFooter = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 0),
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1200,
    width: '100%',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`
    }),
    ...(!open && {
        marginLeft: 0,
        width: '100%'
    })
}));

const StyledLink = styled(Link)(({ theme }) => ({
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    '&:hover': {
        color: theme.palette.primary.main,
        textDecoration: 'underline'
    }
}));

const Footer = () => {
    const leftDrawerOpened = useSelector((state) => state.customization.opened);
    
    return (
        <StyledFooter open={leftDrawerOpened}>
            <Container maxWidth={false} sx={{ px: 2 }}>
                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'space-between',
                    alignItems: { xs: 'center', sm: 'flex-start' },
                    gap: 2,
                    width: '100%'
                }}>
                    <Typography variant="body2" color="text.secondary">
                        © 2025 Kmillion Tecnologia LTDA. Todos os direitos reservados.
                    </Typography>
                    
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: { xs: 1, sm: 2 },
                        alignItems: 'center'
                    }}>
                        <StyledLink href="/politica-de-privacidade" target="_blank" rel="noopener noreferrer">
                            Política de Privacidade
                        </StyledLink>
                        <StyledLink href="/termos-de-uso" target="_blank" rel="noopener noreferrer">
                            Termos de Uso
                        </StyledLink>
                    </Box>
                </Box>
            </Container>
        </StyledFooter>
    );
};

export default Footer;
